export default __webpack_public_path__ + "static/media/pharmacy_locked.b1e4a0bb.png";